import type { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { create } from 'zustand'
import { combine, devtools, persist } from 'zustand/middleware'

export const useTimelineNoteComposerDialogStore = create(
  devtools(
    persist(
      combine(
        {
          open: false,
          message: '',
          onSuccess: null as ((comment: CommentCommunication) => any) | null,
        },
        (set) => ({
          setOpen: (
            open: boolean,
            {
              onSuccess,
            }: { onSuccess?: (comment: CommentCommunication) => void } = {}
          ) =>
            !open ? set({ open, onSuccess: null }) : set({ open, onSuccess }),
          setMessage: (message: string) => set({ message }),
        })
      ),
      {
        name: 'timeline-note-composer-dialog',
      }
    )
  )
)
